module.exports = __webpack_public_path__ + "static/media/header-img.cf5392ba.png";